import { IDs } from '../helpers/IDs';
import * as React from 'react';

export function hasEffizienznetzwerk(data: any): boolean {
    data = data || {};
    const anwendungskontext: string = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).anwendungskontext || null;

    return (
        anwendungskontext === 'netzwerkarbeitsbuch'
        && ['cfm', 'steuer'].indexOf(data.MODUL_SELECTED) === -1
    );
}

export function svgToPng(svg: any, width: number, height: number, resizeRatio = 1) {
    // Je größer resizeRatio, desto bessere Bildqualität, Empfehlenswert = 3
    return new Promise((resolve, reject) => {
        const svgImage = new Image();
        svgImage.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width * resizeRatio;
            canvas.height = height * resizeRatio;
            const canvasCtx = canvas.getContext('2d');
            canvasCtx.drawImage(svgImage, 0, 0, canvas.width, canvas.height);
            canvas.style.width = canvas.width + 'px';
            canvas.style.height = canvas.height + 'px';
            const imgData = canvas.toDataURL('image/png');
            // document.body.appendChild(canvas);
            resolve(imgData);
        };
        svgImage.onerror = () => {
            console.error('Fehler: svgToPng onload');
        };
        svgImage.src = svg;
    });
}


export function getBetaLabel(colUse?: string) {
    if (!colUse) {
        colUse = '#00b050';
    }
    return <span
        style={{
            backgroundColor: '#FFF', color: colUse , border: '1px solid ' + colUse,
            paddingLeft: '5px', paddingRight: '5px', marginLeft: '5px', borderRadius: '5px'
        }}
    >BETA</span>;
}

export function isAppleDevice() {
    return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
}
